var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitLogoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 49,
    viewBox: "0 0 60 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 29.6429C60 41.4775 34.7526 48.5 22.3881 48.5C10.0235 48.5 0 38.9061 0 27.0714C0 15.2368 18.9787 0.5 31.3433 0.5C43.7079 0.5 60 17.8082 60 29.6429Z",
    fill: "#212935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitLogoBackground);
export default __webpack_public_path__ + "static/media/benefitLogoBackground.9a724e1b11a146c3d63532b59da2eab4.svg";
export { ForwardRef as ReactComponent };